/* BONE — theme JS */
(function () {
  'use strict';

  var money = function (cents) {
    return (window.Shopify && window.Shopify.formatMoney)
      ? window.Shopify.formatMoney(cents)
      : (cents / 100).toFixed(2);
  };

  /* ---------- sticky header ---------- */
  var hdr = document.querySelector('[data-header]');
  if (hdr) {
    var coverEl = document.querySelector('[data-stage]') || document.querySelector('[data-cover]');
    var onScroll = function () {
      var y = window.scrollY;
      var overCover = coverEl ? y < coverEl.offsetHeight - 90 : false;
      hdr.classList.toggle('is-over', overCover);
      hdr.classList.toggle('is-stuck', !overCover && y > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- mobile nav ---------- */
  var burger = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('.nav');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      burger.textContent = open ? 'Close' : 'Menu';
      burger.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }

  /* ---------- reveal on scroll ---------- */
  var rv = document.querySelectorAll('.rv');
  if (rv.length) {
    // Anything already on screen is shown at once, with no transition.
    // Only content the visitor has to scroll to gets the reveal, so a page
    // never arrives looking half-rendered.
    var vh = window.innerHeight || document.documentElement.clientHeight;
    rv.forEach(function (el) {
      if (el.getBoundingClientRect().top < vh * 0.92) el.classList.add('is-now');
    });

    if (!('IntersectionObserver' in window)) {
      rv.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });
      rv.forEach(function (el) { io.observe(el); });
    }

    // Safety net: if an IntersectionObserver callback is ever missed (throttled
    // renderer, backgrounded tab), content would stay invisible forever. This
    // sweep re-checks on scroll so nothing can be permanently hidden.
    var sweepPending = false;
    var sweep = function () {
      sweepPending = false;
      var h = window.innerHeight || document.documentElement.clientHeight;
      rv.forEach(function (el) {
        if (el.classList.contains('is-in') || el.classList.contains('is-now')) return;
        var box = el.getBoundingClientRect();
        if (box.top < h && box.bottom > 0) el.classList.add('is-in');
      });
    };
    window.addEventListener('scroll', function () {
      if (sweepPending) return;
      sweepPending = true;
      setTimeout(sweep, 120);
    }, { passive: true });
    window.addEventListener('resize', function () { setTimeout(sweep, 120); }, { passive: true });
  }

  /* ---------- custom cursor ---------- */
  var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  var cursor = null;
  if (fine) {
    cursor = document.createElement('div');
    cursor.className = 'cursor';
    cursor.innerHTML = '<span class="cursor__txt">Second glance</span>';
    document.body.appendChild(cursor);

    var cx = -300, cy = -300, tx = -300, ty = -300, raf = null;
    var tick = function () {
      cx += (tx - cx) * 0.22;
      cy += (ty - cy) * 0.22;
      cursor.style.transform = 'translate(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px) translate(-50%,-50%)';
      raf = (Math.abs(tx - cx) > 0.4 || Math.abs(ty - cy) > 0.4) ? requestAnimationFrame(tick) : null;
    };
    window.addEventListener('mousemove', function (e) {
      tx = e.clientX; ty = e.clientY;
      if (!raf) raf = requestAnimationFrame(tick);
    }, { passive: true });
  }

  /* ---------- the second-glance reveal ---------- */
  function bindLooks(scope) {
    (scope || document).querySelectorAll('.look__frame').forEach(function (frame) {
      if (frame.dataset.bound) return;
      frame.dataset.bound = '1';
      var card = frame.closest('.look') || frame.parentNode;

      var open = function () {
        frame.classList.add('is-open'); card.classList.add('is-open');
        frame.setAttribute('aria-pressed', 'true');
        if (cursor) cursor.classList.add('is-label');
      };
      var close = function () {
        frame.classList.remove('is-open'); card.classList.remove('is-open');
        frame.setAttribute('aria-pressed', 'false');
        if (cursor) cursor.classList.remove('is-label');
      };

      if (fine) {
        frame.addEventListener('mouseenter', open);
        frame.addEventListener('mouseleave', close);
      }
      frame.addEventListener('click', function (e) {
        e.preventDefault();
        frame.classList.contains('is-open') ? close() : open();
      });
      frame.addEventListener('focus', open);
      frame.addEventListener('blur', close);
    });
  }
  bindLooks(document);
  document.addEventListener('shopify:section:load', function (e) { bindLooks(e.target); });

  /* ---------- opening stage: one window, many media ----------
     Cross-fade only. Every slide occupies the same fixed frame,
     so nothing moves when the content changes.                */
  var stage = document.querySelector('[data-stage]');
  if (stage) {
    var slides = stage.querySelectorAll('.window__slide');
    var cues = stage.querySelectorAll('.stage__cue');
    var counter = stage.querySelector('[data-count]');
    var current = 0;
    var timer = null;
    var HOLD = 3600;

    var pad = function (n) { return (n < 10 ? '0' : '') + n; };

    function show(next) {
      if (next === current) return;
      slides[current].classList.remove('is-on');
      if (cues[current]) cues[current].classList.remove('is-on');

      current = (next + slides.length) % slides.length;

      slides[current].classList.add('is-on');
      if (cues[current]) cues[current].classList.add('is-on');
      if (counter) counter.textContent = pad(current + 1) + ' / ' + pad(slides.length);

      var vid = slides[current].querySelector('video');
      if (vid) { vid.currentTime = 0; vid.play().catch(function () {}); }
    }

    function start() {
      if (timer) return;
      timer = setInterval(function () { show(current + 1); }, HOLD);
    }
    function stop() { clearInterval(timer); timer = null; }

    cues.forEach(function (cue, i) {
      cue.addEventListener('mouseenter', function () { stop(); show(i); });
      cue.addEventListener('focus', function () { stop(); show(i); });
      cue.addEventListener('click', function () { stop(); show(i); });
      cue.addEventListener('mouseleave', start);
      cue.addEventListener('blur', start);
    });

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();

    document.addEventListener('visibilitychange', function () {
      document.hidden ? stop() : start();
    });
  }


  /* ---------- cover: the index summons the image ---------- */
  var cover = document.querySelector('[data-cover]');
  if (cover) {
    var cards = cover.querySelectorAll('.cover__card');
    var rows = cover.querySelectorAll('.cover__row');
    var cCount = cover.querySelector('[data-cover-count]');
    var cIndex = 0;
    var cTimer = null;
    var pad2 = function (n) { return (n < 10 ? '0' : '') + n; };

    function coverShow(n) {
      if (n === cIndex) return;
      cards[cIndex].classList.remove('is-on');
      if (rows[cIndex]) rows[cIndex].classList.remove('is-on');
      cIndex = (n + cards.length) % cards.length;
      cards[cIndex].classList.add('is-on');
      if (rows[cIndex]) rows[cIndex].classList.add('is-on');
      if (cCount) cCount.textContent = pad2(cIndex + 1) + ' / ' + pad2(cards.length);
      var cv = cards[cIndex].querySelector('video');
      if (cv) { cv.currentTime = 0; cv.play().catch(function () {}); }
    }
    function coverStart() {
      if (cTimer) return;
      cTimer = setInterval(function () { coverShow(cIndex + 1); }, 4000);
    }
    function coverStop() { clearInterval(cTimer); cTimer = null; }

    rows.forEach(function (row, n) {
      row.addEventListener('mouseenter', function () { coverStop(); coverShow(n); });
      row.addEventListener('focus', function () { coverStop(); coverShow(n); });
      row.addEventListener('click', function () { coverStop(); coverShow(n); });
      row.addEventListener('mouseleave', coverStart);
      row.addEventListener('blur', coverStart);
    });

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) coverStart();
    document.addEventListener('visibilitychange', function () {
      document.hidden ? coverStop() : coverStart();
    });
  }



  /* ---------- aperture intro ----------
     Plates cut through one fixed frame, on top of each other, then the
     stage opens. Runs once per visit; any key, click or scroll skips it. */
  var intro = document.querySelector('[data-intro]');
  if (intro) {
    var plates = intro.querySelectorAll('.intro__plate');
    var introReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var seen = false;
    try { seen = sessionStorage.getItem('bone-intro') === '1'; } catch (e) {}

    var finishIntro = function () {
      if (intro.dataset.done) return;
      intro.dataset.done = '1';
      try { sessionStorage.setItem('bone-intro', '1'); } catch (e) {}
      intro.classList.add('is-open');
      setTimeout(function () { intro.classList.add('is-done'); }, 620);
      setTimeout(function () {
        intro.hidden = true;
        document.body.style.overflow = '';
      }, 1500);
    };

    if (seen || introReduce || !plates.length) {
      intro.hidden = true;
    } else {
      document.body.style.overflow = 'hidden';
      var HOLD = 420;
      var LEAD = 760;
      var pi = 0;
      var stepPlate = function () {
        if (intro.dataset.done) return;
        // Hold the last plate while the stage opens, or the frame goes black.
        if (pi + 1 >= plates.length) { finishIntro(); return; }
        plates[pi].classList.remove('is-on');
        pi += 1;
        plates[pi].classList.add('is-on');
        var pv = plates[pi].querySelector('video');
        if (pv) { pv.currentTime = 0; pv.play().catch(function () {}); }
        setTimeout(stepPlate, HOLD);
      };
      setTimeout(function () { intro.classList.add('is-marked'); }, 420);
      setTimeout(stepPlate, LEAD);
      setTimeout(finishIntro, 7000);
      ['click', 'keydown', 'wheel', 'touchstart'].forEach(function (evt) {
        window.addEventListener(evt, finishIntro, { once: true, passive: true });
      });

      var skipBtn = document.createElement('button');
      skipBtn.className = 'intro__skip';
      skipBtn.type = 'button';
      skipBtn.textContent = 'Skip';
      skipBtn.addEventListener('click', finishIntro);
      intro.appendChild(skipBtn);
    }
  }

  /* ---------- variant picker ---------- */
  var variantJsonEl = document.querySelector('[data-variant-json]');
  if (variantJsonEl) {
    var variants = [];
    try { variants = JSON.parse(variantJsonEl.textContent); } catch (err) { variants = []; }

    var form = document.getElementById('ProductForm');
    var idInput = document.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-price]');
    var addBtn = document.querySelector('[data-add-to-cart]');
    var addLabel = document.querySelector('[data-add-label]');

    var selectedOptions = function () {
      return Array.prototype.map.call(
        document.querySelectorAll('[data-option-selector]:checked'),
        function (i) { return i.value; }
      );
    };

    var updateVariant = function () {
      var chosen = selectedOptions();
      if (!chosen.length) return;
      var match = variants.find(function (v) {
        return chosen.every(function (val, i) { return v.options[i] === val; });
      });

      if (!match) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Unavailable';
        return;
      }

      if (idInput) idInput.value = match.id;
      if (priceEl) {
        var html = money(match.price);
        if (match.compare_at_price && match.compare_at_price > match.price) {
          html += ' <s class="price__was">' + money(match.compare_at_price) + '</s>';
        }
        priceEl.innerHTML = '<span class="price">' + html + '</span>';
      }
      if (addBtn) addBtn.disabled = !match.available;
      if (addLabel) addLabel.textContent = match.available ? 'Add to bag' : 'Sold out';

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
    };

    document.querySelectorAll('[data-option-selector]').forEach(function (input) {
      input.addEventListener('change', updateVariant);
    });

    /* add to cart -> open the drawer */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addLabel) addLabel.textContent = 'Adding…';
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams(new FormData(form)).toString()
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () { return refreshCart(); })
          .then(function () {
            openDrawer();
            if (addLabel) addLabel.textContent = 'Add to bag';
          })
          .catch(function () {
            // Never strand the visitor: fall back to a normal form post.
            if (addLabel) addLabel.textContent = 'Add to bag';
            form.submit();
          });
      });
    }
  }

  /* ---------- cart drawer ---------- */
  var drawer = document.getElementById('CartDrawer');

  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    // Force a reflow so the panel has a start state to transition FROM.
    // requestAnimationFrame is throttled in background/inactive tabs, which
    // left the drawer un-hidden but still translated off-screen.
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; }, 550);
  }

  function refreshCart() {
    return fetch(window.Shopify.routes.root + '?section_id=cart-drawer-fragment')
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        var body = document.querySelector('[data-cart-body]');
        if (html && body) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.querySelector('[data-cart-body-inner]');
          if (next) body.innerHTML = next.innerHTML;
        }
        return fetch(window.Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var count = document.querySelector('[data-cart-count]');
        if (count && cart) count.textContent = cart.item_count > 0 ? ' (' + cart.item_count + ')' : '';
        return cart;
      });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-open]');
    if (opener && drawer) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && !drawer.hidden) closeDrawer();
  });

  /* ---------- product image zoom ---------- */
  var zoom = document.querySelector('[data-zoom]');
  if (zoom) {
    var zStage = zoom.querySelector('[data-zoom-stage]');
    var zImg = zoom.querySelector('[data-zoom-img]');
    var zClose = zoom.querySelector('[data-zoom-close]');
    var zTrigger = null, zTimer = null, zRaf = null;
    var zRatio = 4 / 3, zw = 0, zh = 0, zx = 0, zy = 0, ztx = 0, zty = 0;
    var clamp01 = function (v) { return Math.min(1, Math.max(0, v)); };

    var zPaint = function () {
      zImg.style.transform = 'translate3d(' + zx.toFixed(1) + 'px,' + zy.toFixed(1) + 'px,0)';
    };
    // Pan follows the pointer with a little lag, so it glides instead of
    // snapping to every mouse event.
    var zTick = function () {
      zx += (ztx - zx) * 0.16;
      zy += (zty - zy) * 0.16;
      zPaint();
      zRaf = (Math.abs(ztx - zx) > 0.3 || Math.abs(zty - zy) > 0.3) ? requestAnimationFrame(zTick) : null;
    };
    var zAim = function (rx, ry, jump) {
      ztx = -(zw - window.innerWidth) * rx;
      zty = -(zh - window.innerHeight) * ry;
      if (jump) { zx = ztx; zy = zty; zPaint(); }
      else if (!zRaf) zRaf = requestAnimationFrame(zTick);
    };
    var zLayout = function (rx, ry) {
      var vw = window.innerWidth, vh = window.innerHeight;
      if (fine) {
        // Big enough to read the fabric, and always taller than the screen.
        zw = Math.max(vw * 1.5, (vh * 1.35) / zRatio);
        zh = zw * zRatio;
        zImg.style.width = zw + 'px';
        zAim(rx, ry, true);
      } else {
        zImg.style.width = (vw * 2.2) + 'px';
        zStage.scrollLeft = (vw * 2.2 - vw) * rx;
        zStage.scrollTop = (vw * 2.2 * zRatio - vh) * ry;
      }
    };

    var openZoom = function (trigger, e) {
      var thumb = trigger.querySelector('img');
      if (!thumb) return;
      clearTimeout(zTimer);
      zTrigger = trigger;
      var r = trigger.getBoundingClientRect();
      var fromPointer = e && e.detail > 0;
      var rx = fromPointer ? clamp01((e.clientX - r.left) / r.width) : 0.5;
      var ry = fromPointer ? clamp01((e.clientY - r.top) / r.height) : 0.5;
      if (thumb.naturalWidth) zRatio = thumb.naturalHeight / thumb.naturalWidth;

      zImg.src = thumb.currentSrc || thumb.src;
      zImg.alt = thumb.alt || '';
      zoom.classList.toggle('is-touch', !fine);
      zoom.hidden = false;
      document.body.style.overflow = 'hidden';
      void zoom.offsetWidth;
      zoom.classList.add('is-open');
      zLayout(rx, ry);
      zClose.focus({ preventScroll: true });

      var hi = trigger.dataset.zoomSrc;
      if (hi && zImg.src !== hi) {
        var pre = new Image();
        pre.onload = function () { if (zTrigger === trigger && !zoom.hidden) zImg.src = hi; };
        pre.src = hi;
      }
    };
    var closeZoom = function () {
      if (zoom.hidden) return;
      zoom.classList.remove('is-open');
      document.body.style.overflow = '';
      if (zRaf) { cancelAnimationFrame(zRaf); zRaf = null; }
      zTimer = setTimeout(function () { zoom.hidden = true; zImg.removeAttribute('src'); }, 200);
      if (zTrigger) zTrigger.focus({ preventScroll: true });
      zTrigger = null;
    };

    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-zoom-open]');
      if (t) { e.preventDefault(); openZoom(t, e); }
    });
    // Start fetching the large file as soon as the pointer arrives.
    document.addEventListener('mouseover', function (e) {
      var t = e.target.closest('[data-zoom-open]');
      if (!t || t.dataset.warm) return;
      t.dataset.warm = '1';
      (new Image()).src = t.dataset.zoomSrc;
    });
    zClose.addEventListener('click', closeZoom);
    zStage.addEventListener('click', function () { if (fine) closeZoom(); });
    zStage.addEventListener('mousemove', function (e) {
      zAim(clamp01(e.clientX / window.innerWidth), clamp01(e.clientY / window.innerHeight), false);
    });
    window.addEventListener('resize', function () { if (!zoom.hidden) zLayout(0.5, 0.5); });
    document.addEventListener('keydown', function (e) {
      if (zoom.hidden) return;
      if (e.key === 'Escape') closeZoom();
      if (e.key === 'Tab') { e.preventDefault(); zClose.focus(); }
    });
  }

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var down = e.target.closest('[data-qty-down]');
    var up = e.target.closest('[data-qty-up]');
    if (!down && !up) return;
    var wrap = (down || up).closest('.qty');
    var input = wrap && wrap.querySelector('.qty__input');
    if (!input) return;
    var min = parseInt(input.getAttribute('min') || '0', 10);
    var val = parseInt(input.value || '0', 10) + (up ? 1 : -1);
    input.value = Math.max(min, val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input) return;
    var key = input.dataset.key;
    if (!key) return;
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: parseInt(input.value, 10) })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCart(); })
      .catch(function () { window.location.reload(); });
  });
})();
